import React from 'react';
import Modal from '../../components/Modals/Modal';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import DividerSimple from '../../components/Dividers/DividerSimple';
import useApp from '../../store/app/appContext';
import EmailInput from '../../components/Inputs/EmailInput';
import validateEmail from '../../utils/validateEmail';

function UpdateEmailModal({
  setShowUpdateEmail,
  showUpdateEmail
}) {
  
  const {
    updateEmail,
    appState : { user }
  } = useApp();

  const [emails, _setEmails] = React.useState({
    old: null,
    new: null,
    confirm: null,
  })

  const setEmails = (data) => _setEmails({ ...emails, ...data })

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });
  
  const handleCancel = () => {
    setShowUpdateEmail(false);
    setFormError({
      field: '',
      msg: ''
    });
  }

  const handleSubmit = () => {
    if (!validateEmail(emails.old) || emails.old === '' || emails.old === null) {
      setFormError({
        field: 'no-old',
        msg: "Please enter a valid email."
      })
      return;
    }
    if (emails.old !== user.email) {
      setFormError({
        field: 'bad-old',
        msg: "This email doesn't match our records."
      })
      return;
    }
    if (!validateEmail(emails.new) || emails.new === '' || emails.new === null) {
      setFormError({
        field: 'bad-email',
        msg: "Please enter a valid email."
      })
      return;
    }
    if (emails.new !== emails.confirm) {
      setFormError({
        field: 'no-match',
        msg: "Emails don't match."
      })
      return;
    }
    
    updateEmail({newEmail: emails.new, oldEmail: emails.old});
    setShowUpdateEmail(false);
  }

  return (
    <Modal title={'Update email'} show={showUpdateEmail} hide={handleCancel}>
      <div className='flex flex-col justify-between mt-8'>
        <EmailInput value={emails.old} label={'Old email'} onChange={(e) => setEmails({ old: e.target.value })}/>
        {(formError.field === 'no-old' || formError.field === 'bad-old') &&
        <span className="text-red-400 text-sm">{formError.msg}</span>
        }
        <DividerSimple/>
        <EmailInput value={emails.new} label={'New email'} onChange={(e) => setEmails({ new: e.target.value })}/>
        <div className='mt-4'/>
        <EmailInput value={emails.confirm} label={'Confirm email'} onChange={(e) => setEmails({ confirm: e.target.value })}/>
        {(formError.field === 'no-match' || formError.field === 'bad-email') &&
        <span className="text-red-400 text-sm">{formError.msg}</span>
        }
        <div className='grid grid-cols-2 gap-x-2 mt-6'>
          <SecondaryButton onClick={handleCancel} text='Cancel'/>  
          <PrimaryButton onClick={handleSubmit} text='Update'/>
        </div>
      </div>
    </Modal>
  )
}

export default UpdateEmailModal;
